import { motion } from "framer-motion";
import { useLang } from "../i18n";

const WA_NUMBER = "18557732747";

const WhatsAppIcon = () => (
  <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
    <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.59 4.46 1.71 6.4L3.2 28.8l6.58-1.67a12.74 12.74 0 0 0 6.22 1.6h.01c7.06 0 12.79-5.74 12.79-12.8s-5.73-12.73-12.8-12.73zm0 23.36h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-4.02 1.02 1.07-3.86-.25-.4a10.55 10.55 0 0 1-1.63-5.65c0-5.86 4.77-10.63 10.64-10.63a10.6 10.6 0 0 1 10.63 10.66c0 5.86-4.77 10.57-10.64 10.57zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.72.16-.21.32-.82 1.04-1.01 1.25-.18.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.9-1.78-2.22-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.72-1.73-.98-2.37-.26-.62-.52-.54-.72-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.12 1.09-1.12 2.66s1.15 3.09 1.31 3.3c.16.21 2.26 3.45 5.47 4.84.76.33 1.36.53 1.83.68.77.24 1.47.21 2.02.13.62-.09 1.89-.77 2.16-1.52.27-.75.27-1.39.19-1.52-.08-.13-.29-.21-.61-.37z" />
  </svg>
);

export const WhatsAppButton = () => {
  const { t } = useLang();
  return (
    <motion.a
      href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent("Hello 7 Seas Group USA — I'd like to inquire about lumber export.")}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      aria-label={t("whatsapp")}
      title={t("whatsapp")}
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.2, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      className="group fixed bottom-6 right-6 z-[60] flex items-center gap-0 overflow-hidden rounded-full bg-[#25D366] text-white shadow-lg shadow-black/25 transition-transform duration-300 hover:scale-105"
    >
      <span className="flex h-14 w-14 shrink-0 items-center justify-center">
        <WhatsAppIcon />
      </span>
      <span className="max-w-0 whitespace-nowrap pr-0 font-mono text-xs uppercase tracking-[0.15em] opacity-0 transition-[max-width,opacity,padding] duration-500 group-hover:max-w-[260px] group-hover:pr-5 group-hover:opacity-100">
        {t("whatsapp")}
      </span>
    </motion.a>
  );
};
